<template>
<div id="logsistema_grupo">
  <div>
    <v-breadcrumbs :items="breadcrumbs">
      <v-icon slot="divider">forward</v-icon>
    </v-breadcrumbs>
  </div>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12>
        <base-material-card color="primary" icon="library_books" title="Consultar Log de Accesos" class="px-5 py-3">

          <v-card-actions>

            <v-spacer></v-spacer>

            <exportar-excel v-tippy style="cursor: pointer" :data="datafiltered" :exportFields="logsistema.camposexcel" name="LogAccesos.xlsx">
              <v-btn fab x-small dark color="success" title="Exportar" v-tippy>
                <v-icon dark>get_app</v-icon>
              </v-btn>
            </exportar-excel>
          </v-card-actions>

          <v-card-text>
            <div id="filtros">
              <v-card>
                <v-card-title>
                  <v-card class="primary darken-2 white--text titulomodal">
                    <v-icon class="white--text">search</v-icon>&nbsp;
                    <span class="subheading">
                      <strong>Filtros de Búsqueda</strong>
                    </span>
                  </v-card>
                  <v-spacer></v-spacer>
                  &nbsp;
                </v-card-title><br />
                <v-form ref="form" lazy-validation>
                  <v-card-text>
                    <v-container grid-list-md text-xs-center @keyup.enter="buscar()">
                      <v-layout row wrap>

                        <v-flex x12 s4 m4 l4>
                          <v-autocomplete v-model="usuarioSelected" :items="usuarios" :hide-no-data="true" :hide-selected="true" item-text="username" item-value="id_usuario" label="Selecciona un Usuario">
                          </v-autocomplete>
                        </v-flex>
                      </v-layout>
                      <v-layout row wrap>
                        <v-flex x12 s6 m6 l6>
                          <v-menu offset-x ref="menu1" :close-on-content-click="false" v-model="menu1" :nudge-right="40" transition="scale-transition" offset-y max-width="290px" min-width="290px">
                            <template v-slot:activator="{ on }">
                              <v-text-field v-model="model.fecha_ini" label="Fecha Inicial" prepend-icon="event" @blur="
                                  model.fecha_ini = parseDate(model.fecha_ini)
                                " v-mask="'####-##-##'" v-on="on" :rules="[rules.required, validaAnio, validaFecha]"></v-text-field>
                            </template>
                            <v-date-picker v-model="model.fecha_ini" no-title @input="menu1 = false" locale="es-mx"></v-date-picker>
                          </v-menu>
                        </v-flex>
                        <v-flex x12 s6 m6 l6>
                          <v-menu offset-x ref="menu2" :close-on-content-click="false" v-model="menu2" :nudge-right="40" transition="scale-transition" offset-y max-width="290px" min-width="290px">
                            <template v-slot:activator="{ on }">
                              <v-text-field v-model="model.fecha_fin" label="Fecha Final" prepend-icon="event" @blur="
                                  model.fecha_fin = parseDate(model.fecha_fin)
                                " v-mask="'####-##-##'" v-on="on" :rules="[rules.required, validaAnio, validaFecha]"></v-text-field>
                            </template>
                            <v-date-picker v-model="model.fecha_fin" no-title @input="menu2 = false" locale="es-mx"></v-date-picker>
                          </v-menu>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-form>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn @click.native="limpiarModel()">
                    <v-icon>cancel</v-icon> Limpiar Filtros
                  </v-btn>
                  <v-btn color="success" :loading="loading" @click.native="buscar()">
                    <v-icon>search</v-icon> Buscar
                  </v-btn>
                </v-card-actions>
              </v-card>
            </div>
            <br />
            <p></p>
            <v-tabs grow style="margin-bottom: 30px;">
              <v-tabs-slider color="primary"></v-tabs-slider>
              <v-tab :key="'login'">Acceso al Sistema</v-tab>
              <v-tab :key="'cliente'">Acceso a Clientes</v-tab>

              <v-tab-item :key="'login'">
                <div id="datagrid">

                  <v-client-table ref="vuetable" :data="logsistema.items.login" :columns="columns" :options="options" class="elevation-2 pa-2">
                    <template slot="noResults">
                      <v-alert :value="true" icon="info" color="info">No se encontró ningun registro</v-alert>
                    </template>

                    <template slot="actions" slot-scope="props">
                      <v-speed-dial :id="props.row.id" direction="left" open-on-hover>
                        <template v-slot:activator>
                          <v-btn :id="props.row.id" x-small fab dark color="primary">
                            <v-icon>reorder</v-icon>
                          </v-btn>
                        </template>

                        <v-btn x-small fab dark color="blue" @click.native="true" title="Ver Información del Registro" v-tippy>
                          <v-icon>info</v-icon>
                        </v-btn>
                      </v-speed-dial>
                    </template>
                  </v-client-table>
                </div>
              </v-tab-item>
              <v-tab-item :key="'cliente'">
                <div id="datagrid_cliente">

                  <v-client-table ref="vuetable" :data="logsistema.items.cliente" :columns="columns_clientes" :options="options_clientes" class="elevation-2 pa-2">
                    <template slot="noResults">
                      <v-alert :value="true" icon="info" color="info">No se encontró ningun registro</v-alert>
                    </template>

                    <template slot="actions" slot-scope="props">
                      <v-speed-dial :id="props.row.id" direction="left" open-on-hover>
                        <template v-slot:activator>
                          <v-btn :id="props.row.id" x-small fab dark color="primary">
                            <v-icon>reorder</v-icon>
                          </v-btn>
                        </template>

                        <v-btn x-small fab dark color="blue" @click.native="true" title="Ver Información del Registro" v-tippy>
                          <v-icon>info</v-icon>
                        </v-btn>
                      </v-speed-dial>
                    </template>
                  </v-client-table>
                </div>
              </v-tab-item>
            </v-tabs>
          </v-card-text>
        </base-material-card>
      </v-flex>
    </v-layout>
  </v-container>
</div>
</template>

<script>
import axios from "axios";
import moment from "moment";

export default {
  components: {},
  data: () => ({
    rfcs: [],
    name: "datagrid",
    columns: ["usuario", "fecha", "ip"],
    columns_clientes: ["usuario", "fecha", "cliente"],
    show_loading: false,
    options: {
      filterable: ["usuario", "fecha", "ip"],
      sortable: ["usuario", "fecha", "ip"],
    },
    options_clientes: {
      filterable: ["usuario", "fecha", "cliente"],
      sortable: ["usuario", "fecha", "cliente"],
    },
    URL: "",
    menu1: false,
    menu2: false,
    breadcrumbs: [{
        text: "Inicio",
        disabled: false,
        to: "/admin"
      },
      {
        text: "Utilerías",
        disabled: true,
        to: ""
      },
      {
        text: "Consultar Log de de Accesos",
        disabled: true,
        to: ""
      }
    ],
    loading: false,
    modal: false,
    search: "",
    model: {
      usuario: "",
      fecha_ini: "",
      fecha_fin: "",
    },
    rules: {
      required: v => !!v || "Este campo es requerido"
    },
    usuarios: [],
    usuariosArray: [],
    usuarioSelected: "",
    logsistema: {
      camposexcel: {
        Usuario: "usuario",
        Fecha: "fecha",
        IP: "ip",
        Fecha: {
          field: "fecha",
          callback: function(value) {
            return moment(String(value)).format("YYYY-MM-DD");
          }
        },
      },

      items: {}
    },
    tipos_usuario: [],
  }),

  computed: {
    datafiltered() {
      if (this.$refs.vuetable != null) {
        return this.$refs.vuetable.allFilteredData;
      } else {
        return this.logsistema.items;
      }

    },
  },
  methods: {
    parseDate(date) {
      //Formato  YYYY-MM-DD
      if (!date) return null;
      return moment(String(date)).format("YYYY-MM-DD");
    },
    validaFecha: function(fecha) {
      if (fecha == "Invalid date")
        return "Fecha no válida."
    },
    validaAnio: function() {
      if (this.model.fecha_de != "" && this.model.fecha_a != "") {
        var inicio = moment(this.model.fecha_de, "YYYY-MM-DD");
        var fin = moment(this.model.fecha_a, "YYYY-MM-DD");
        var diferencia = fin.diff(inicio, 'days')
        if (diferencia < 0)
          return "La Fecha Final no debe ser menor a la Fecha Inicial."
      }
      return true;
    },
    validaDias: function() {
      if (this.model.fecha_de != "" && this.model.fecha_a != "") {
        var inicio = moment(this.model.fecha_de, "YYYY-MM-DD");
        var fin = moment(this.model.fecha_a, "YYYY-MM-DD");
        var diferencia = fin.diff(inicio, 'days')
        if (diferencia < 0)
          return "La Fecha Final no debe ser menor a la Fecha Inicial."
        if (Math.abs(diferencia) > 31)
          return "Periodo máximo de consulta 31 dias. Favor de verificar."
      }
      return true;
    },
    limpiarModel: function() {
      for (var k in this.model) {
        this.model[k] = "";
      }
      this.filtros = 0;
      this.usuarioSelected = "Todos";
    },
    buscar() {
      if (!this.$refs.form.validate()) {
        return false;
      }
      let datos = {
        usuario: this.usuarioSelected != "Todos" ? [this.usuarioSelected] : this.usuariosArray,
        fecha_ini: this.model.fecha_ini ? this.model.fecha_ini : "*",
        fecha_fin: this.model.fecha_fin ? this.model.fecha_fin : "*"
      };

      for (var k in datos) {
        this.filtros = 0;
        if (datos[k] != "*") {
          this.filtros = 1;
          break;
        }
      }

      if (this.filtros == 1) {
        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');

        axios
          .post(this.$hostname + "accesos_usuarios/consulta_log/", datos)
          .then(res => {
            if (typeof res.data != "undefined") {
              this.logsistema.items = res.data;

            } else {
              this.$swal({
                position: "center",
                type: "error",
                title: "¡Operación no Permitida!",
                text: "Ocurrió un error al consultar los datos"
                //showConfirmButton: false,
              });
            }
          })
          .catch(error => {
            this.$swal({
              position: "center",
              type: "error",
              title: "¡Operación no Permitida!",
              text: "Ocurrió un error al consultar los datos"
              //showConfirmButton: false,
            });
            console.log(error);
          })
          .then(() => {
            this.$root.$dialogLoader.hide();
          });
      } else {
        this.$swal({
          type: "info",
          title: "Información!",
          text: "Debe seleccionar al menos un filtro para la búsqueda."
        });
      }
    },
    cargarUsuarios: function() {
      let idCliente = this.$local_storage.get("id_cliente");

      if (idCliente > 0) {

        let data = {
          cliente: idCliente,
          sistema: this.$sistema
        };

        axios
          .post(this.$hostname + "usuarios/obtener_usuarios_cliente/", data)
          .then(res => {
            if (typeof res.data !== "undefined") {
              let data = [];
              let ids = [];

              for (var i = 0; i < res.data.length; i++) {
                ids.push(res.data[i].id);
                data.push({
                  id_usuario: res.data[i].id,
                  username: res.data[i].email,
                });
              }

              this.usuariosArray = ids;
              this.usuarios = data;
              this.$root.$dialogLoader.hide();
            }
          })
          .catch(err => {
            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text: "Ocurrió un error al obtener los usuarios.",
              footer: ""
            });
            console.log(err);
            this.$root.$dialogLoader.hide();
          });
      } else {
        axios
          .get(this.$hostname + "usuarios/")
          .then(response => {
            let tipos_usuario = this.tipos_usuario;

            let datos = response.data.filter(function(usuario) {
              return tipos_usuario.includes(usuario.tipo_usuario)
            });

            let ids = [];
            for (var i = 0; i < datos.length; i++)
              ids.push(datos[i].id_usuario);

            this.usuariosArray = ids;
            this.usuarios = datos;
            this.$root.$dialogLoader.hide();
          })
          .catch(error => {
            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text: "Ocurrió un error al obtener los usuarios.",
              footer: ""
            });
          })
          .then(() => {
            this.$root.$dialogLoader.hide();
          });
      }
    },

    getTiposUsuario: function() {
      axios
        .post(this.$hostname + "tipos-usuarios/get_all/")
        .then(response => {
          let datos = response.data.filter(function(tipo) {
            return (
              tipo.nombre == "Grupo" ||
              tipo.nombre == "Super Usuario" ||
              tipo.nombre == "Soporte"
            );
          });

          let tipos = [];

          for (var i = 0; i < datos.length; i++) {
            tipos.push(datos[i].id_tipo_usuario);
          }

          this.tipos_usuario = tipos;
          this.cargarUsuarios();
        })
        .catch(error => {
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener los tipos de usuario.",
            footer: ""
          });
        });
    },

  }, //methods
  created: function() {
    this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
    this.limpiarModel();
    this.getTiposUsuario();
  }
};
</script>
<style scoped>
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active),
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active)>.v-icon,
.theme--light.v-tabs>.v-tabs-bar .v-tab--disabled {
  color: black;
  font-size: small;
  background-color: #EEEEEE;
  padding: 0px;
}

.v-tabs .v-tabs-bar .v-tab.v-tab--active {
  color: white;
  font-size: small;
  background-color: #df7205;
  padding: 0px;
  font-weight: bold;

}

.v-tabs-slider-wrapper {
  left: 0 !important;
}

.table-bordered thead th,
.table-bordered thead td {
  font-size: x-small !important;
}

.text-number {
  text-align: right;
}
</style>
